module.exports = __webpack_public_path__ + "img/dxfy-left.4e5ad08b.png";